import { jsx as _jsx } from "react/jsx-runtime";
import { translate } from '../../../strings/i18n';
import StatusMessageBox from '../StatusMessageBox';
const ExistingUser = () => {
    return (_jsx(StatusMessageBox, { messageTitle: translate('existingUserMessageBox.existingUser'), messageDescription: translate('existingUserMessageBox.usersList') }));
};
export default ExistingUser;
